import { SentryErrorComponent } from '@components/Fallback'
import {
  CheckPermissionsWrapper,
  Operations,
  Permission,
} from '@lib/permissions'
import { createFileRoute, Outlet } from '@tanstack/react-router'

const commentaryReadPermission = new Permission(['commentary'], Operations.Read)

const CommentaryBoxRoute = () => (
  <CheckPermissionsWrapper permissions={[commentaryReadPermission]}>
    <Outlet />
  </CheckPermissionsWrapper>
)

export const Route = createFileRoute('/_auth/o/$orgId/commentaryBox')({
  component: CommentaryBoxRoute,
  errorComponent: SentryErrorComponent,
  loader: async () => ({
    crumb: 'Commentary Box',
  }),
})
